/* Impression SCDM — LA DISTANCE DE COUPE, EN MILLIMETRES.

   ============================================================================
   POURQUOI
   ============================================================================
   Le curseur CONTOUR regle la largeur du liston blanc autour du dessin, et
   c est exactement la ou passe la lame : le trait magenta de scdm-coupe.js
   suit le bord exterieur de ce liston. Le client regle donc deja la distance
   entre son dessin et la coupe — sans jamais la voir.

   Et il ne peut pas la deviner, parce que le curseur ne stocke pas une
   distance : il stocke une FRACTION du cote de l autocollant. La meme
   position de curseur donne 1,5 mm sur un collant de 2 po et 9 mm sur un
   panneau de 12 po. C est correct pour l apparence — un gros collant merite
   un liston proportionnel — mais ca ne dit rien a quelqu un qui veut « 2 mm ».

   Ce fichier ajoute les deux choses qui manquaient : la distance affichee en
   millimetres, et la possibilite de la fixer au chiffre exact.

   ============================================================================
   LA CONVERSION
   ============================================================================
   Dans scdm-forme.js :  b = min(largeur, hauteur) x etat.bordure
   ou b est la largeur du liston en pixels de toile. Physiquement :

       distance (mm) = etat.bordure x plus petit cote (po) x 25,4

   Et l inverse, pour poser une distance voulue :

       etat.bordure = mm / 25,4 / plus petit cote (po)

   Le plus petit cote vient de SCDM_DATA.TAILLES pour un format standard, ou
   de etat.larg / etat.haut sur mesure.

   ============================================================================
   CE QU ON RECOMMANDE, ET POURQUOI
   ============================================================================
   1 a 3 mm. En dessous de 1 mm, la moindre derive de la lame mord dans le
   dessin — la repetabilite de coupe est de l ordre de 0,2 mm, mais le vinyle
   travaille, la planche glisse, et le zero ne pardonne rien. Au-dela de 3 mm,
   ce n est plus une coupe collee au dessin : c est un liston blanc, ce qui est
   un choix esthetique parfaitement valable mais qu il faut faire expres.

   ZERO EST PERMIS. Certains clients le veulent vraiment — une decoupe franche
   dans le dessin, sans aucun blanc. On l autorise, on l ecrit sur la commande,
   et on avertit a l ecran. On ne decide pas a la place du client ; on lui dit
   ce qu on sait.

   ============================================================================
   CE QUI PART SUR LA COMMANDE
   ============================================================================
   Une propriete « Contour de coupe » avec la distance en millimetres. Sans
   elle, l atelier voit la ligne magenta sur l epreuve mais ne sait pas si le
   client a demande une valeur precise ou laisse le reglage par defaut.

   Charge depuis snippets/scdm-minimum.liquid, en defer, apres scdm-forme.js. */

(function () {
  'use strict';

  function texteContour(cle, repli, params) {
    var pont = document.getElementById('scdmContourI18n');
    var texte = (pont && pont.getAttribute('data-' + cle)) || repli;
    Object.keys(params || {}).forEach(function (nom) {
      texte = texte.split('{' + nom + '}').join(String(params[nom]));
    });
    return texte;
  }

  function htmlContour(cle, repli) {
    return texteContour(cle, repli).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }


  var IDEAL_MIN = 1.0;      /* mm */
  var IDEAL_MAX = 3.0;      /* mm */
  var RACCOURCIS = [0, 1, 2, 3, 5];   /* mm */

  var bloc = null, champ = null, verdict = null, rangee = null;
  var enEcriture = false;

  function S() { return window.SCDM; }
  function D() { return window.SCDM_DATA; }
  function curseur() { return document.getElementById('scdmBordure'); }

  /* LE BLOC SUIT LE CURSEUR — 9 septembre 2026.
     Sur du lettrage decoupe il n y a pas de liston : les lettres sont taillees
     au ras du trace. assets/scdm-lettrage-decoupe.js cache donc le curseur
     Contour et remet etat.bordure a zero. Il n y a plus ni distance a regler
     ni distance a ecrire sur la commande : ce bloc disparait avec lui, et la
     propriete « Contour de coupe » ne part pas.
     On lit l etat du curseur plutot que le materiau : un seul endroit decide
     de cacher, ici on ne fait que suivre. */
  function contourOffert() {
    var b = curseur();
    if (!b) return false;
    if (b.hidden) return false;
    if (b.style && b.style.display === 'none') return false;
    return true;
  }

  function nb(n) {
    return (Math.round(n * 10) / 10).toFixed(1).replace('.', ',');
  }

  /* --------------------------------------------------------- la conversion */

  /* Le plus petit cote de la piece, en pouces. C est lui qui donne l echelle :
     le liston est une fraction de ce cote-la, pas de la diagonale. */
  function coteMinPo() {
    var s = S(), d = D();
    var e = s && s.etat;
    if (!e || !d) return 0;
    if (e.taille === 'custom') {
      var l = Number(e.larg) || 0, h = Number(e.haut) || 0;
      return Math.min(l, h);
    }
    for (var i = 0; i < (d.TAILLES || []).length; i++) {
      if (d.TAILLES[i].id === e.taille) return Number(d.TAILLES[i].po) || 0;
    }
    var t = parseFloat(e.taille);
    return isFinite(t) ? t : 0;
  }

  function mmCourant() {
    var e = S() && S().etat;
    if (!e) return 0;
    return (Number(e.bordure) || 0) * coteMinPo() * 25.4;
  }

  function fractionPour(mm) {
    var c = coteMinPo();
    if (!(c > 0)) return null;
    return mm / 25.4 / c;
  }

  /* Les bornes du curseur, traduites en millimetres a la taille courante.
     On ne peut pas promettre 5 mm sur un collant de trois quarts de pouce :
     le curseur s arrete avant, et il faut le dire au lieu de mentir. */
  function bornesMm() {
    var b = curseur();
    var c = coteMinPo();
    if (!b || !(c > 0)) return null;
    var mn = parseFloat(b.min), mx = parseFloat(b.max);
    if (!isFinite(mn)) mn = 0;
    if (!isFinite(mx)) mx = 0.1;
    return { min: mn * c * 25.4, max: mx * c * 25.4 };
  }

  /* ------------------------------------------------------------- le reglage */

  function poser(mm) {
    var b = curseur();
    var f = fractionPour(mm);
    if (!b || f === null) return;
    var mn = parseFloat(b.min), mx = parseFloat(b.max);
    if (isFinite(mn)) f = Math.max(mn, f);
    if (isFinite(mx)) f = Math.min(mx, f);
    b.value = String(f);
    /* « input » : c est l evenement que scdm.js ecoute pour redessiner. */
    b.dispatchEvent(new Event('input', { bubbles: true }));
    b.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ------------------------------------------------------------------ le rendu */

  function style() {
    if (document.getElementById('scdmContourMmStyle')) return;
    var s = document.createElement('style');
    s.id = 'scdmContourMmStyle';
    s.textContent = [
      '.scdm-cmm{margin:8px 0 0;padding:10px 12px;border-radius:9px;',
      'border:1px solid var(--trait,#2A3342);background:var(--fond2,#131922);',
      'font-size:12.5px;line-height:1.5}',
      '.scdm-cmm[hidden]{display:none !important}',
      '.scdm-cmm .cmm-t{display:block;margin:0 0 8px;font-size:11px;letter-spacing:.09em;',
      'text-transform:uppercase;color:var(--slate,#98A1B2);font-weight:600}',
      '.scdm-cmm .cmm-l{display:flex;align-items:center;gap:8px;flex-wrap:wrap}',
      '.scdm-cmm input{width:70px;padding:6px 8px;border-radius:6px;',
      'border:1px solid var(--trait,#2A3342);background:var(--fond,#0D1219);',
      'color:var(--encre,#EDF1F7);font-size:14px;font-weight:600;text-align:right;',
      'font-variant-numeric:tabular-nums}',
      '.scdm-cmm .cmm-u{color:var(--slate,#98A1B2);margin-left:-3px}',
      '.scdm-cmm .cmm-r{display:inline-flex;gap:5px;margin-left:auto;flex-wrap:wrap}',
      '.scdm-cmm .cmm-r button{padding:5px 9px;border-radius:6px;cursor:pointer;',
      'border:1px solid var(--trait,#2A3342);background:transparent;',
      'color:var(--slate,#98A1B2);font-size:12px;font-weight:600}',
      '.scdm-cmm .cmm-r button:hover{color:var(--encre,#EDF1F7);border-color:#4A5768}',
      '.scdm-cmm .cmm-r button.on{background:#EC1E79;border-color:#EC1E79;color:#fff}',
      '.scdm-cmm .cmm-v{margin:8px 0 0;font-size:12px;line-height:1.45}',
      '.scdm-cmm .cmm-v.ok{color:#4CAF7D}',
      '.scdm-cmm .cmm-v.att{color:#E0A544}',
      '.scdm-cmm .cmm-v.neutre{color:var(--slate,#98A1B2)}',
      'html.scdm-jour .scdm-cmm{background:#F4F6F9;border-color:#D8DEE7}',
      'html.scdm-jour .scdm-cmm .cmm-t{color:#5A6678}',
      'html.scdm-jour .scdm-cmm input{background:#FFFFFF;border-color:#D8DEE7;color:#12203A}',
      'html.scdm-jour .scdm-cmm .cmm-u{color:#5A6678}',
      'html.scdm-jour .scdm-cmm .cmm-r button{border-color:#D8DEE7;color:#5A6678}',
      'html.scdm-jour .scdm-cmm .cmm-r button:hover{color:#12203A;border-color:#A9B4C4}',
      'html.scdm-jour .scdm-cmm .cmm-v.ok{color:#1E7A4C}',
      'html.scdm-jour .scdm-cmm .cmm-v.att{color:#8A5A10}'
    ].join('');
    document.head.appendChild(s);
  }

  function poserBloc() {
    if (bloc && document.body.contains(bloc)) return true;
    var b = curseur();
    if (!b) return false;
    rangee = b.closest('.fld') || b.parentElement;
    if (!rangee || !rangee.parentElement) return false;

    bloc = document.createElement('div');
    bloc.className = 'scdm-cmm';
    bloc.id = 'scdmContourMm';
    bloc.innerHTML =
      '<span class="cmm-t">' + htmlContour('heading', 'Distance entre le dessin et la ligne de coupe') + '</span>' +
      '<div class="cmm-l">' +
        '<input type="number" id="scdmContourVal" min="0" max="50" step="0.1" ' +
        'inputmode="decimal" aria-label="' + htmlContour('input_label', 'Distance de coupe en millimètres') + '">' +
        '<span class="cmm-u">mm</span>' +
        '<span class="cmm-r" id="scdmContourRac"></span>' +
      '</div>' +
      '<p class="cmm-v neutre" id="scdmContourVerdict"></p>';
    rangee.parentElement.insertBefore(bloc, rangee.nextSibling);

    champ = document.getElementById('scdmContourVal');
    verdict = document.getElementById('scdmContourVerdict');

    document.getElementById('scdmContourRac').innerHTML = RACCOURCIS.map(function (m) {
      return '<button type="button" data-mm="' + m + '">' + m + '</button>';
    }).join('');

    document.getElementById('scdmContourRac').addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button[data-mm]') : null;
      if (!t) return;
      e.preventDefault();
      poser(parseFloat(t.getAttribute('data-mm')));
      setTimeout(peindre, 0);
    });

    function lire() {
      if (enEcriture) return;
      var v = parseFloat(String(champ.value).replace(',', '.'));
      if (!isFinite(v) || v < 0) return;
      poser(v);
      setTimeout(peindre, 0);
    }
    champ.addEventListener('change', lire);
    champ.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); lire(); champ.blur(); }
    });

    b.addEventListener('input', function () { setTimeout(peindre, 0); });
    return true;
  }

  function peindre() {
    if (!bloc && !poserBloc()) return;

    var s = S();
    var e = s && s.etat;
    var pret = !!(e && e.img && coteMinPo() > 0 && contourOffert());
    bloc.hidden = !pret;
    if (!pret) return;

    var mm = mmCourant();

    /* On n ecrase pas ce que le client est en train de taper. */
    if (document.activeElement !== champ) {
      enEcriture = true;
      champ.value = nb(mm);
      enEcriture = false;
    }

    var rac = document.getElementById('scdmContourRac');
    if (rac) {
      [].forEach.call(rac.children, function (btn) {
        var v = parseFloat(btn.getAttribute('data-mm'));
        btn.classList.toggle('on', Math.abs(v - mm) < 0.25);
      });
    }

    var bo = bornesMm();
    var txt, cls;
    if (mm < 0.15) {
      txt = texteContour('flush', "Coupe franche dans le dessin, sans aucune marge blanche. La lame se répète à 0,2 mm près, mais le vinyle travaille : un léger décalage mordra dans votre image. À choisir en connaissance de cause.");
      cls = 'att';
    } else if (mm < IDEAL_MIN) {
      txt = texteContour('tight', "Très serré. En dessous de 1 mm, une petite dérive de coupe devient visible. Montez à 1 mm si vous voulez rester collé au dessin sans risque.");
      cls = 'att';
    } else if (mm <= IDEAL_MAX) {
      txt = texteContour('ideal', "Idéal. Entre 1 et 3 mm, la coupe suit votre dessin de près et absorbe les écarts de la lame.");
      cls = 'ok';
    } else if (mm <= 6) {
      txt = texteContour('visible', "Liston blanc visible autour du dessin. C’est un choix esthétique courant sur les autocollants ; pour une coupe collée au dessin, descendez entre 1 et 3 mm.");
      cls = 'neutre';
    } else {
      txt = texteContour('wide', "Large bordure blanche ({mm} mm). Assurez-vous que c’est voulu — elle sera imprimée et payée comme le reste de la surface.", { mm: nb(mm) });
      cls = 'neutre';
    }

    if (bo && mm >= bo.max - 0.05) {
      txt += texteContour('maximum', " Le curseur est à son maximum pour ce format ({mm} mm).", { mm: nb(bo.max) });
    }

    verdict.textContent = txt;
    verdict.className = 'cmm-v ' + cls;
  }

  /* --------------------------------------------------------- sur la commande */

  function accrocher() {
    document.addEventListener('click', function (e) {
      var b = (e.target && e.target.closest) ? e.target.closest('#scdmAjouter') : null;
      if (!b) return;
      /* Pas de liston sur du lettrage decoupe : rien a ecrire. */
      if (!contourOffert()) return;
      var mm = mmCourant();
      setTimeout(function () {
        var liste = (S() && S().commande) || [];
        if (!liste.length) return;
        var d = liste[liste.length - 1];
        d.props = d.props || {};
        d.props['Contour de coupe'] = nb(mm) + ' mm entre le dessin et la ligne de coupe' +
          (mm < 0.15 ? ' — coupe franche demandée par le client' : '');
      }, 80);
    }, false);
  }

  /* ------------------------------------------------------------- demarrage */

  function demarrer() {
    if (!document.getElementById('scdmConfig')) return;
    style();
    if (!poserBloc()) return;
    accrocher();
    ['input', 'change'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(peindre, 0); }, true);
    });
    setInterval(peindre, 400);
    peindre();
  }

  function quandPret(n) {
    if (curseur() && window.SCDM && window.SCDM_DATA) return demarrer();
    if ((n || 0) > 100) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
